module.exports = __webpack_public_path__ + "static/media/fabric_icon.b1089a02.svg";